// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Viewer from "v-viewer"
import "viewerjs/dist/viewer.css"
import "@/pages/newfont.css"

import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import {
  read,
  smsCode,
  smsLogin,
  bookInfo,
  bookPage
} from '@/api/api'
import cusDialog from '@/components/cus-dialog.vue'
Vue.component('cus-dialog', cusDialog)
import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
Vue.component('vue-draggable-resizable', VueDraggableResizable)
import Logindialog from '@/components/logindialog'
import BuyConfirm from "@/components/buyconfirm.vue"
Vue.component(Logindialog.name, Logindialog)
Vue.component(BuyConfirm.name, BuyConfirm)
Vue.use(ElementUI)


Vue.config.productionTip = false
// //模拟登陆
// let mobile = 18842769061
// smsCode({mobile,scene:'LOGIN'}).then(res=>{
//   smsLogin({uuid:res.uuid,smsCode:res.smsCode,mobile}).then(res=>{
//     localStorage.setItem('token','Bearer '+res.token);
//   })
// })
/* eslint-disable no-new */
zhLocale.el.pagination = {
  goto: '前往',
  pagesize: '条/页',
  total: '共 {total} 條',
  pageClassifier: '页'
}

Vue.use(ElementUI, {
  locale: zhLocale,
})
Vue.prototype.formParam = obj => {
  let str = "?"
  for (let key in obj) {
    str += key + "=" + obj[key] + "&"
  }
  return str
}
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>',
  beforeCreate () {
    Vue.prototype.$bus = this
  }
})

Viewer.setDefaults({
  Options: {
    // 'button': true,
    // 'transition': true,
  },

  stop: function (e) {
    console.log(e, '退出')

  },
  // viewed() {
  // this.viewer.zoomTo(1)
  // }

})

Vue.use(Viewer)
// document.addEventListener('keydown', (e) => {
//   if (e.key === 'F12' || (e.ctrlKey && e.shiftKey && e.key === 'I')) {
//     e.preventDefault()
//     alert('调试功能已被禁用！') // 可选：显示警告提示
//   }
// })



// swiper版本5
// import css from 'swiper/css/swiper.min.css'
// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import { Swiper, SwiperSlide } from "vue-awesome-swiper"
// 第二个参数可配置默认选项
// export default () => {
//   Vue.use(VueAwesomeSwiper, {
//     css
//   })
// }



// WEBPACK FOOTER //
// ./src/main.js